import type { Match, Query } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ params }: Match, { filter, orderby, keyword }: Query) => {
	const { projectKey, issueKey } = params;
	const pageIdPrefix = 'new-issue-navigator';

	let pageId = '';
	try {
		pageId = `${pageIdPrefix}${
			(projectKey !== null && projectKey !== undefined ? `-${projectKey}` : '') +
			(issueKey !== null && issueKey !== undefined ? `-${issueKey}` : '') +
			(filter !== undefined ? `-${filter}` : '') +
			(orderby !== undefined ? `-${orderby}` : '') +
			(keyword !== undefined ? `-${keyword}` : '')
		}`;
	} catch {
		pageId = pageIdPrefix;
	}
	return pageId;
};
